<template>
	<div class="flex flex-row justify-content-between align-items-center m-2 bg-grey">
		<div class="flex flex-row align-items-center">
			<div class="pi pi-circle-fill text-xs mr-2" />
			<span class="mr-2">Main menu position:</span>
			<PSelectButton
				:allowEmpty="false"
				:options="options"
				@click="save()"
				aria-labelledby="basic"
				v-model="option"
			/>
		</div>
		<!-- <PButton
			label="Save"
			text
		/>-->
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'
	import Constants from '@/helpers/Constants'
	import PB from '@/brokers/PersistencyBroker'
	import Utils from '@/utils/Utils'
	import EventBus from '@/utils/EventBus'

	export default defineComponent({
		components: {
		},

		data() {
			return {
				before: '',
				option: 'Top',
				options: [
					'Top',
					'Side',
				]
			}
		},

		created() {
			const option = PB.get(Constants.LOCAL_STORAGE_IDS.MENU_POSITION)
			this.option = option ? option : 'Top'
			this.before = this.option
		},

		methods: {
			save() {
				if (this.option != this.before) {
					PB.set(Constants.LOCAL_STORAGE_IDS.MENU_POSITION, this.option)
					Utils.showSuccessMessage('Settings have been saved succcessfully.')
					EventBus.emit(Constants.EVENTS.SET_TOP_MENU_POSITION, this.option == 'Top')
					this.before = this.option
				}
			}
		}
	})
</script>

<style scoped>
</style>
